import { WebchatOptions } from "../../Redux/reduxState";
import { ContainerName } from "../../Redux/reducers/AppReducer";
import { BaseCustomizationEntry } from "../customizeEntries";

export type OptionValueGetter = (key: any, containerName?: ContainerName) => any;

export const getOptionValue = (webchatOptions: WebchatOptions, key: any, containerName: ContainerName = "styleOptions") => {
    const containerValue = containerName === "root"
        ? webchatOptions
        : containerName === "UI.headerOptions"
            ? webchatOptions["UI"]?.["headerOptions"]
            : webchatOptions[containerName];
    return containerValue ? (containerValue as any)[key] : null;
};

const getDependencyValue = (entry: BaseCustomizationEntry, dependencyPath: string, getValue: OptionValueGetter) => {
    const trimmedDependencyPath = dependencyPath.trim();
    if (!trimmedDependencyPath) {
        return true;
    }

    if (trimmedDependencyPath.includes('.')) {
        const pathParts = trimmedDependencyPath.split('.');
        const key = pathParts.pop() as string;
        const containerName = pathParts.join('.') as ContainerName;
        return getValue(key, containerName);
    }

    const valueFromCurrentContainer = getValue(trimmedDependencyPath, entry.containerName);
    if (valueFromCurrentContainer !== undefined && valueFromCurrentContainer !== null) {
        return valueFromCurrentContainer;
    }

    const fallbackContainers: ContainerName[] = ['UI.headerOptions', 'UI', 'styleOptions', 'root'];
    for (const fallbackContainer of fallbackContainers) {
        const fallbackValue = getValue(trimmedDependencyPath, fallbackContainer);
        if (fallbackValue !== undefined && fallbackValue !== null) {
            return fallbackValue;
        }
    }

    return undefined;
};

export const isEntryHidden = (entry: BaseCustomizationEntry, getValue: OptionValueGetter) => {
    if (entry.hidden === true) {
        return true;
    }

    if (!Array.isArray(entry.hidden) || entry.hidden.length === 0) {
        return false;
    }

    return entry.hidden.some((dependencyPath) => {
        const isNegatedDependency = dependencyPath.startsWith('!');
        const normalizedDependencyPath = isNegatedDependency ? dependencyPath.slice(1) : dependencyPath;
        const dependencyValue = Boolean(getDependencyValue(entry, normalizedDependencyPath, getValue));
        return isNegatedDependency ? dependencyValue : !dependencyValue;
    });
};

export const isEntryDisabled = (entry: BaseCustomizationEntry, getValue: OptionValueGetter) => {
    if (entry.disabled === true) {
        return true;
    }

    if (!Array.isArray(entry.disabled) || entry.disabled.length === 0) {
        return false;
    }

    return entry.disabled.some((dependencyPath) => {
        const isNegatedDependency = dependencyPath.startsWith('!');
        const normalizedDependencyPath = isNegatedDependency ? dependencyPath.slice(1) : dependencyPath;
        const dependencyValue = Boolean(getDependencyValue(entry, normalizedDependencyPath, getValue));
        return isNegatedDependency ? !dependencyValue : dependencyValue;
    });
};
